module.exports = __webpack_public_path__ + "img/tab1.709612af.png";